import React, { useState } from 'react'
import ProductTypeModal from '../../Components/ProductTypeModal/ProductTypeModal'

const ProductType = () => {
    const [showProductTypeModal, setShowProductTypeModal] = useState(true);
    
    const handleCloseModal = () => {
        setShowProductTypeModal(false);
    };

    return (
        <div>
            <ProductTypeModal type={showProductTypeModal} onClose={handleCloseModal} />

        </div>
    )
}

export default ProductType
